import BaseModel from '@danhoss/model/BaseModel';

export class ProductModel extends BaseModel {
    constructor() {
        super();

        this._id = Number;
        this._name = String;
        this._symbol = String;
        this._preview = String;
        this._price = Number;
        this._isPersonalized = Boolean;
        this._isGift = Boolean;
        this._giftPrice = String;
        this._url = String;
        this._quantity = Number;
        this._image = String;
        this._image2 = String;
        this._technicalDescription = String;
        this._categoryId = Number;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get symbol() {
        return this._symbol;
    }

    set symbol(value) {
        this._symbol = value;
    }

    get preview() {
        return this._preview;
    }

    set preview(value) {
        this._preview = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get isPersonalized() {
        return this._isPersonalized;
    }

    set isPersonalized(value) {
        this._isPersonalized = value;
    }

    get isGift() {
        return this._isGift;
    }

    set isGift(value) {
        this._isGift = value;
    }

    get giftPrice() {
        return this._giftPrice;
    }

    set giftPrice(value) {
        this._giftPrice = value;
    }

    get url() {
        return this._url;
    }

    set url(value) {
        this._url = value;
    }

    get quantity() {
        return this._quantity;
    }

    set quantity(value) {
        this._quantity = value;
    }

    get image() {
        return this._image;
    }

    set image(value) {
        this._image = value;
    }

    get image2() {
        return this._image2;
    }

    set image2(value) {
        this._image2 = value;
    }

    get technicalDescription() {
        return this._technicalDescription;
    }

    set technicalDescription(value) {
        this._technicalDescription = value;
    }

    get categoryId() {
        return this._categoryId;
    }

    set categoryId(value) {
        this._categoryId = value;
    }
}
